module.exports = __webpack_public_path__ + "img/white-logo.89eb6620.png";